/**
 * @ignore
 * Created by daletan on 6/17/16.
 */

'use strict';
const React = require('react');

const PropTypes = require('prop-types');

// Stores
const UserStore = require('../../global/stores/UserStore.es');
const PriceStore = require('../../global/stores/PriceStore.es.js');
const ItemStore = require('../../newPdp/stores/ItemStore.es');
const TourStore = require('../../components/Tour/TourStore');

// Components
const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');
const Tour = require('../Tour/Tour');
const { RawPriceComponent: PriceComponent } = require('./ReducedPriceComponents');
const ContextComponent = require('../../global/components/ContextComponent');

// Helpers
const SV = require('server-vars');
const { setSession } = require('../Tour/tourActions');
const { type: { TRADE_TOUR, NET_PRICE_TOUR } } = TourStore;
const tourTracking = require('../../global/tracking/tourTracking');
const {pageTypes} = require('dibs-buyer-layout/src/entries/index');

class ReducedPriceTour extends ContextComponent {
    constructor(props) {
        super(props);

        this.onTourOpen = this.onTourOpen.bind(this);
    }

    onTourOpen(payload) {
        const { tradeTour: { onOpen } } = this.props;
        this.context.executeAction(setSession, { type: NET_PRICE_TOUR });
        onOpen(payload);
    }

    render() {
        const {
            pageType,
            netPriceTour,
            tradeTour,
            copy = {},
            isSoldIndividually,
            netPrice,
            priceDisplays,
            currency,
        } = this.props;

        return (
            <Tour
                className="button-wrapper"
                copy={tradeTour.copy}
                dataTn="net-price-trade"
                type={tradeTour.type}
                subType={tradeTour.subType}
                isTourOpen={tradeTour.isTourOpen}
                currentStep={tradeTour.currentStep}
                totalSteps={tradeTour.totalSteps}
                onOpen={this.onTourOpen}
                step={1}
            >
                <Tour
                    copy={netPriceTour.copy}
                    dataTn="net-price"
                    type={netPriceTour.type}
                    subType={netPriceTour.subType}
                    isTourOpen={netPriceTour.isTourOpen}
                    currentStep={netPriceTour.currentStep}
                    totalSteps={netPriceTour.totalSteps}
                    onCtaClick={netPriceTour.onCtaClick}
                    onOpen={netPriceTour.onOpen}
                    step={1}
                >
                    {/* render the net price here */}
                    <PriceComponent
                        float
                        type="net"
                        copy={copy}
                        priceDisplays={priceDisplays}
                        isSoldIndividually={isSoldIndividually}
                        netPrice={netPrice}
                        currency={currency}
                        pageType={pageType}
                    />
                </Tour>
            </Tour>
        );
    }
}

ReducedPriceTour.propTypes = {
    priceDisplays: PropTypes.object.isRequired,
    isSoldIndividually: PropTypes.bool,
    currency: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    netPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    copy: PropTypes.object,
    netPriceTour: PropTypes.object,
    tradeTour: PropTypes.object,
    pageType: PropTypes.string,
};

const Connected = provideContext(
    connectToStores(ReducedPriceTour, [ItemStore, UserStore, TourStore, PriceStore], context => {
        const userStore = context.getStore(UserStore);
        const itemStore = context.getStore(ItemStore);
        const tourStore = context.getStore(TourStore);
        const priceStore = context.getStore(PriceStore);
        const item = itemStore.getItem();
        const processedPriceData = priceStore.processPrice(item);
        const { netPriceData = {}, retailPriceData = {}, priceDisplays } = processedPriceData;
        return {
            copy: itemStore.getCopy(),
            currency: userStore.getCurrency(),
            isSoldIndividually: itemStore.getSoldIndividually(
                netPriceData.model || retailPriceData.model
            ),
            netPrice: netPriceData.price,
            netPriceTour: {
                type: NET_PRICE_TOUR,
                copy: SV.get(`tourCopy.${NET_PRICE_TOUR}`),
                isTourOpen: tourStore.isTourOpen(NET_PRICE_TOUR),
                currentStep: tourStore.getCurrentStep(NET_PRICE_TOUR),
                totalSteps: tourStore.getTotalSteps(NET_PRICE_TOUR),
                onCtaClick: tourTracking.trackCta,
                onOpen: tourTracking.trackOpen,
                onClose: tourTracking.trackClose,
            },
            pageType: pageTypes.PAGE_TYPE.PDP,
            priceDisplays,
            tradeTour: {
                type: TRADE_TOUR,
                subType: priceDisplays.showNetPrice ? 'preQuotedNetPrice' : 'requestNetPrice',
                copy: SV.get(`tourCopy.${TRADE_TOUR}`),
                isTourOpen: tourStore.isTourOpen(TRADE_TOUR),
                currentStep: tourStore.getCurrentStep(TRADE_TOUR),
                totalSteps: tourStore.getTotalSteps(TRADE_TOUR),
                onOpen: tourTracking.trackOpen,
                onClose: tourTracking.trackClose,
            },
        };
    })
);

module.exports = {
    Connected,
    Raw: ReducedPriceTour,
};



// WEBPACK FOOTER //
// ./assets/js/components/ReducedPrice/ReducedPriceWithTour.jsx